import { MTFiltersValuesI, IAdminMinerProof } from "./getMinerList";
import { PostRequest } from "./http/BaseRequest";
import { RecordResponse } from "./http/responses/BaseResponse";

export interface IAdminMiningCalcResponse
  extends RecordResponse<IAdminMinerProof[]> {}
// miner - массив майнеров через запятую,
// mining_persent - процент, как в изменении настроек

export class AdminMiningCalcRequest extends PostRequest {
  constructor(
    miners: string,
    mining_persent: number,
    filters?: MTFiltersValuesI
  ) {
    const params: any = {
      miner: miners,
      mining_persent,
      ...filters,
    };

    if (filters?.search) {
      params.search = JSON.stringify(filters.search);
    }

    super("/admin/miner/settings/mining_proof", params);
  }
}
